module.exports = __webpack_public_path__ + "assets/51f181d75d7ee6e6c588efc73b190ff0.png";